import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "./components/ErrorBoundary";

// Sentry monitoring – graceful no-op if DSN not configured
try {
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
  if (sentryDsn) {
    import('@sentry/react').then(Sentry => {
      Sentry.init({ 
        dsn: sentryDsn, 
        tracesSampleRate: 0.1, 
        environment: process.env.NODE_ENV,
        // Filter out demo user errors from polluting production tracking
        beforeSend(event) {
          if (event.user?.email?.includes('@safekept-demo.co.uk')) {
            return null;
          }
          return event;
        }
      });
    });
  }
} catch (e) { /* Sentry init failure must never break the app */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
